module.exports = __webpack_public_path__ + "assets/img/pros-plus-icon.b110d6ec.svg";